export class BaseNotificationsProvider {
    constructor(namespace) {
        this.namespace = namespace;
    }
    getNamespace() {
        return this.namespace;
    }
    async refresh() {
        try {
            if (this.refreshRequestedCallback) {
                await this.refreshRequestedCallback(this.getNamespace());
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    onRefreshRequested(callback) {
        this.refreshRequestedCallback = callback;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZS1ub3RpZmljYXRpb25zLnByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9ub3RpZmljYXRpb25zL3Byb3ZpZGVycy9iYXNlLW5vdGlmaWNhdGlvbnMucHJvdmlkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUUEsTUFBTSxPQUFnQix5QkFBeUI7SUFLM0MsWUFBc0IsU0FBaUI7UUFDbkMsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7SUFDL0IsQ0FBQztJQUVNLFlBQVk7UUFDZixPQUFPLElBQUksQ0FBQyxTQUFTLENBQUM7SUFDMUIsQ0FBQztJQUtNLEtBQUssQ0FBQyxPQUFPO1FBQ2hCLElBQUk7WUFDQSxJQUFJLElBQUksQ0FBQyx3QkFBd0IsRUFBRTtnQkFDL0IsTUFBTSxJQUFJLENBQUMsd0JBQXdCLENBQUMsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDLENBQUM7YUFDNUQ7U0FDSjtRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1IsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUNwQjtJQUNMLENBQUM7SUFFTSxrQkFBa0IsQ0FBQyxRQUF1RDtRQUM3RSxJQUFJLENBQUMsd0JBQXdCLEdBQUcsUUFBUSxDQUFDO0lBQzdDLENBQUM7Q0FDSiJ9